<template>
  <modal-wrapper :visible="visible" @close="closeModal">
    <div slot="content" style="height: 100%; overflow: scroll; padding-right: .6rem">
      <el-collapse-transition>
        <section v-if="auto_selected" class="adding">
          <div>
            <div class="adding__title">Выберите авто</div>
            <double-input-search
              title="Введите для поиска"
              class="adding__search"
              :show-search-list="showSearchTruck"
              :search-list="truckNumbers"
              :has-error="hasTruckError"
              :loading="isAutoLoading"
              @input-changed="searchTruck"
              @input-blured="showResultTruck"
              @input-selected="selectResultTruck"
            />
            <el-table v-if="isAutoLoading" v-loading="isAutoLoading" :data="drivers" />
            <template v-else>
              <div v-for="truck in autos" :key="truck.id" class="adding__truck">
                <div class="adding__truck-item">
                  <div class="truck__type">Авто</div>
                  <div class="truck__number">{{ truck.state_numbers }}</div>
                </div>
                <div class="adding__truck-item">
                  <div v-if="truck.state_numbers_trailer" class="truck__type">
                    Прицеп
                  </div>
                  <div class="truck__number">
                    {{ truck.state_numbers_trailer }}
                  </div>
                </div>
                <new-button
                  title="Выбрать"
                  type="secondary"
                  width="width98"
                  @button-clicked="handleSelectTruck(truck)"
                />
              </div>
              <div v-if="!autos.length && !showSearchTruck" class="adding__nothing">
                <div class="adding__nothing-warning">
                  {{ hasTruckError ? `По запросу “${searchValue}” ничего не найденно.` : 'Нет автомобилей для выбора' }}
                </div>
                <div class="adding__nothing-add">
                  {{ hasTruckError ? 'Введите другой автомобиль или добавьте новый' : 'Добавьте автомобиль' }}
                </div>
              </div>
            </template>
          </div>
          <new-button
            title="Нет нужного авто в списке"
            type="primary"
            width="fullWidth"
            class="adding__button"
            @button-clicked="makeNedoresponse"
          />
        </section>
      </el-collapse-transition>
      <el-collapse-transition>
        <section v-if="dispather_selected" class="adding">
          <div>
            <div class="selected-auto">
              <div class="selected-auto__wrapper">
                <div class="selected-auto__truck" />
                <div class="selected-auto__title">{{ selected_auto }}</div>
              </div>
              <div class="selected-auto__wrapper" @click="backToTruck">
                <div class="selected-auto__back">Изменить</div>
                <div class="selected-auto__edit" />
              </div>
            </div>
            <div class="adding__title">Выберите водителя</div>
            <double-input-search
              title="Введите для поиска"
              class="adding__search"
              :show-search-list="showSearchDriver"
              :search-list="driverFios"
              :has-error="hasDriverError"
              @input-changed="searchDriver"
              @input-blured="showResultDriver"
              @input-selected="selectResultDriver"
            />
            <el-table v-if="isLoading" v-loading="isLoading" :data="drivers" />
            <template v-else>
              <div
                v-for="driver in drivers"
                :key="driver.id"
                class="adding__truck"
              >
                <div class="adding__truck-driver">
                  <div class="truck__type">Водитель</div>
                  <div class="truck__number">
                    {{ driver.fio || '(нет данных)' }}
                  </div>
                </div>
                <new-button
                  title="Выбрать"
                  type="secondary"
                  width="width98"
                  @button-clicked="handleSelectDriver(driver)"
                />
              </div>
              <div v-if="!drivers.length && !showSearchDriver" class="adding__nothing">
                <div class="adding__nothing-warning">
                  {{ hasDriverError ? `По запросу “${searchValue}” ничего не найденно.` : 'Нет водителей для выбора' }}
                </div>
                <div class="adding__nothing-add">
                  {{ hasDriverError ? 'Введите другого водителя или добавьте нового' : 'Добавьте водителя ' }}
                </div>
              </div>
            </template>
          </div>
          <new-button
            title="Водителя нет в списке"
            type="primary"
            width="fullWidth"
            class="adding__button"
            @button-clicked="makeNedoresponse"
          />
        </section>
      </el-collapse-transition>
      <el-collapse-transition>
        <section v-if="requestSelected" :class="[ 'adding', { 'mod-success': isRequestSuccess }]">
          <el-table v-if="loading" v-loading="loading" :data="drivers" />
          <template v-else>
            <div>
              <template v-if="isRequestSuccess">
                <div class="adding__success-title">Спасибо за заявку!</div>
                <div class="adding__success-description">
                  Ожидайте sms сообщения о записи на погрузку.
                </div>
                <bid-mobile-brief :bid="bid" :day="day" :freight="freight" />
              </template>
              <template v-if="noMoreRequests || isBlackList">
                <div class="adding__error-title">Запись запрещена </div>
                <div class="adding__error-description">
                  {{ addingErrorDescription }}
                </div>
              </template>
            </div>
            <new-button
              v-if="isRequestSuccess || isBlackList"
              title="Вернуться на главную"
              type="primary"
              width="fullWidth"
              class="adding__button"
              @button-clicked="beforeClose(Number(isRequestSuccess))"
            />
            <new-button
              v-if="noMoreRequests"
              title="Перейти в рейсы"
              type="primary"
              width="fullWidth"
              class="adding__button"
              @button-clicked="$router.push('/flights-mobile')"
            />
          </template>
        </section>
      </el-collapse-transition>
    </div>
  </modal-wrapper>
</template>

<script>
import { GET_FILTER_DRIVERS } from '@/store/actions/drivers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import BidMobileBrief from '../../BidMobileBrief'
import DoubleInputSearch from '@/components/Drivers/DoubleInputSearch/DoubleInputSearch'
import ModalWrapper from './ModalWrapper'
import NewButton from '@/components/Drivers/NewButton/NewButton'
const Responses = RepositoryFactory.get('responses')

export default {
  name: 'DriverAddMobile',
  components: {
    BidMobileBrief,
    ModalWrapper,
    NewButton,
    DoubleInputSearch,
  },
  props: {
    day: {
      type: Object,
      default: () => {},
    },
    infoSource: {
      type: [Number, String],
      default: 0,
    },
    added: {
      type: Object,
      default: () => {},
    },
    bid: {
      type: Object,
      default: () => ({}),
    },
    freight: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selected_auto: '',
      showSearchTruck: false,
      hasTruckError: false,
      searchValue: '',
      selected_carrier_inn: '',
      selected_driver: '',
      showSearchDriver: false,
      hasDriverError: false,
      bid_request: {
        load_day_id: this.day.id,
        info_source_id: this.infoSource,
        automobile_id: 0,
        dispatcher_id: 0,
        driver_id: 0,
      },
      auto_selected: true,
      dispather_selected: false,
      loading: false,
      requestSelected: false,
      isRequestSuccess: false,
      noMoreRequests: false,
      isBlackList: false,
      addingErrorDescription: '',
    }
  },
  computed: {
    ...mapGetters({
      getByKey: 'userProfile/getByKey',
      isLoading: 'drivers/getLoading',
      driversList: 'drivers/getDrivers',
      getAutos: 'autos/getAutos',
      isAutoLoading: 'autos/getAutoLoading',
    }),
    drivers() {
      return this.driversList && this.driversList.length
        ? this.driversList.filter(d => !this.added.drivers.includes(d.id))
        : []
    },
    autos() {
      return this.getAutos && this.getAutos.length
        ? this.getAutos.filter(d => !this.added.autos.includes(d.id))
        : []
    },
    // списки номеров авто для отображения в выпадашке инпута поиска
    truckNumbers() {
      return this.autos.map(item => item.state_numbers)
    },
    // списки ФИО водителей для отображения в выпадашке инпута поиска
    driverFios() {
      return this.drivers.map(item => item.fio)
    },
  },
  async mounted() {
    await this.fetchAutos()
  },
  methods: {
    ...mapActions({
      fetchAutosNew: 'autos/fetchAutosNew',
    }),
    fetchAutos(search = '') {
      this.fetchAutosNew({ org_id: this.curUserOrgId, search })
    },

    // обработка ввода значений в инпут поиска авто
    searchTruck(value) {
      this.hasTruckError = false

      if (value.length > 2) {
        this.fetchAutos(value)
        this.showSearchTruck = true
      }
      if (!value.length) {
        this.showSearchTruck = false
        this.fetchAutos()
      }
    },
    // конец ввода строки поиска авто
    showResultTruck(value) {
      this.showSearchTruck = false

      if (!this.autos.length) {
        this.hasTruckError = true
        this.searchValue = value
      }
    },
    // выбор номера авто из выпадающего списка
    selectResultTruck(value) {
      this.fetchAutos(value)
      this.showSearchTruck = false
    },

    // обработка ввода значений в инпут поиска водителя
    searchDriver(value = '') {
      this.hasDriverError = false

      if (value.length > 2) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          fio: value,
          carrier_inn: this.selected_carrier_inn,
        })
        this.showSearchDriver = true
      }
      if (!value.length) {
        this.showSearchDriver = false
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          carrier_inn: this.selected_carrier_inn,
        })
      }
    },
    // конец ввода строки поиска водителя
    showResultDriver(value) {
      this.showSearchDriver = false
      if (!this.drivers.length) {
        this.hasDriverError = true
        this.searchValue = value
      }
    },
    // выбор ФИО водителя из выпадающего списка
    selectResultDriver(value) {
      this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
        fio: value,
        carrier_inn: this.selected_carrier_inn,
      })
      this.showSearchDriver = false
    },

    // обработка выбранной машины
    handleSelectTruck(truck) {
      const { state_numbers, carrier_inn, id } = truck

      this.selected_auto = state_numbers
      this.selected_carrier_inn = carrier_inn
      this.bid_request.automobile_id = id
      this.auto_selected = false
      this.dispather_selected = true
      this.searchDriver()
    },
    // обработка выбранного водителя
    handleSelectDriver(driver) {
      const { fio, dispatcher_id, id } = driver

      this.selected_driver = fio
      this.bid_request.dispatcher_id = dispatcher_id
      this.bid_request.driver_id = id
      this.dispather_selected = false
      this.requestSelected = true
      this.createBidRequest()
    },
    // переход к созданию заявки на респонс (с неполными данными)
    makeNedoresponse() {
      this.requestSelected = true
      this.createBidRequest()
    },
    // подготовка и создание реквеста
    createBidRequest() {
      this.bid_request.user_org_id = this.curUserOrgId
      this.loading = true
      // обработка заявки на респонс (с неполными данными)
      if (!this.bid_request.driver_id) {
        this.auto_selected = false
        this.dispather_selected = false
        this.bid_request.user_org_inn = this.cur_org_inn
        Responses.postResponseRequest(this.bid_request)
          .then(() => {
            this.isRequestSuccess = true
          })
          .catch(err => {
            if (err.response.status === 422) {
              this.addingErrorDescription = err.response.data[0].message
              this.noMoreRequests = true
            } else {
              this.errHandler(err)
            }
          })
          .finally(() => (this.loading = false))
      }
      // обработка респонса (с полными данными)
      else {
        Responses.postResponse(this.bid_request)
          .then(() => {
            this.isRequestSuccess = true
          })
          .catch(err => {
            if (err.response.status === 422) {
              this.addingErrorDescription = err.response.data[0].message
              this.isBlackList = true
            } else {
              this.errHandler(err)
            }
          })
          .finally(() => (this.loading = false))
      }
    },
    clearForm() {
      this.selected_auto = ''
      this.selected_carrier_inn = ''
      this.selected_driver = ''
      this.bid_request = {
        load_day_id: this.day.id,
        automobile_id: 0,
        dispatcher_id: 0,
        driver_id: 0,
      }
      this.auto_selected = true
      this.dispather_selected = false
      this.requestSelected = false
      this.isRequestSuccess = false
      this.noMoreRequests = false
      this.isBlackList = false
      this.addingErrorDescription = ''
    },
    beforeClose(flag = 0) {
      this.$emit('changed', flag)
      this.clearForm()
    },
    // возврат из окна выбора водителя в окно выбора машины
    backToTruck() {
      this.fetchAutos()
      this.auto_selected = true
      this.dispather_selected = false
      this.hasDriverError = false
    },
    // закрытие модалки из любого экрана
    closeModal() {
      if (this.isRequestSuccess) {
        this.$router.push({ name: 'FlightsMobile' })
      }
      this.clearForm()
      this.fetchAutos()
      this.$emit('close-truck')
    },
  },
}
</script>

<style lang="sass" scoped>
.adding
  display: flex
  flex-direction: column
  &.mod-success
    justify-content: space-between
    height: 100%

.adding__title
  margin: 2rem 0 1.6rem
  font-weight: 800
  font-size: 2rem
  line-height: 2.8rem
  color: #181818

.adding__search
  margin-bottom: 2rem

.adding__truck
  display: flex
  justify-content: space-between
  align-items: center
  height: 6.4rem
  border-top: 1px solid #D7D7D7
  &-auto
    width: 9.2rem
  &-driver
    width: 19.7rem
  .truck__type
    margin-bottom: 0.2rem
    font-weight: 400
    font-size: 1.2rem
    line-height: 1.6rem
    color: #747474
  .truck__number
    font-weight: 700
    font-size: 1.4rem
    line-height: 1.8rem
    color: #181818
.adding__nothing
  display: flex
  flex-direction: column
  justify-content: center
  height: 6.4rem
  border-top: 1px solid #D7D7D7
  &-warning
    margin-bottom: 0.2rem
    font-weight: 700
    font-size: 1.4rem
    line-height: 1.8rem
    color: #ED2121
  &-add
    font-weight: 400
    font-size: 1.2rem
    line-height: 1.6rem
    color: #747474
.selected-auto
  display: flex
  justify-content: space-between
  align-items: center
  height: 3.2rem
  margin-top: 1.6rem
  &__wrapper
    display: flex
    align-items: center
  &__truck
    width: 3.2rem
    height: 3.2rem
    margin-right: .8rem
    background: url('~@/assets/img/new-truck.svg') no-repeat center
    background-color: $mainColor
    border-radius: .8rem
  &__title
    font-weight: 700
    font-size: 1.6rem
    line-height: 2rem
    color: #181818
  &__back
    font-weight: 800
    font-size: 1.4rem
    line-height: 1.6rem
    color: $mainColor
  &__edit
    width: 1.6rem
    height: 1.6rem
    margin-left: .9rem
    background: url('~@/assets/img/new-edit.svg') no-repeat center
.adding__button
  margin-top: 2.2rem

.adding__success-title
  margin: 2rem 0 .4rem
  font-weight: 800
  font-size: 2.2rem
  line-height: 3rem
  color: $mainColor
.adding__success-description
  width: 81%
  margin-bottom: 2.4rem
  font-size: 1.4rem
  font-weight: 400
  line-height: 1.8rem
  color: #5C5C5C

.adding__error-title
  margin: 2rem 0 .8rem
  font-weight: 800
  font-size: 2.4rem
  line-height: 3.2rem
  color: #ff0000
.adding__error-description
  margin-bottom: 2.2rem
  font-size: 1.4rem
  font-weight: 400
  line-height: 1.8rem
  color: #5C5C5C
  word-break: normal
</style>
